<template>
  <history-list :entity-id="entityId" :entity-type-id="entityTypeId" />
</template>

<script lang="ts">
import HistoryList from '@/components/history/HistoryList.vue'
import { ENTITY_TYPE } from '@/utils/constants'

export default {
  name: 'TaskHistoryTab',
  components: { HistoryList },
  props: {
    entityId: { type: [Number, String], required: true },
  },
  setup() {
    return {
      entityTypeId: ENTITY_TYPE.TASK,
    }
  },
}
</script>
